import dom from '../../utils/dom';
import AccountCreateUpdateFormHandler from '../AccountCreateUpdateFormHandler';


window.tnew.page.initialize = ({ isAddressVerificationEnabled, stateFilterConfig, isRecaptchaEnabled }) => {
  const $form = dom.find('#tn-account-register-form');

  new AccountCreateUpdateFormHandler($form, isAddressVerificationEnabled, stateFilterConfig, null, isRecaptchaEnabled);
};



// WEBPACK FOOTER //
// ./V7/account/create/account-create.js